import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./components/SetupMajors')

const SetupMajorsModule = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => {
    const Component = Module.default
    return <Component {...props} />
  }
})

export const SetupMajors = SetupMajorsModule
